import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  Col,
  Input,
  Modal,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from "reactstrap";
import { eliminateParticipants } from "store/actions/contestAction";
import { getVoters } from "store/actions/contestAction";
import { winnerAmbassador } from "store/actions/contestAction";
import { updateContestLevel } from "store/actions/contestAction";
import { getBrandAmbassadorEliminatedParticipants } from "store/actions/contestAction";
import { getParticipants } from "store/actions/contestAction";
import { getBrandAmbassodarContests } from "store/actions/contestAction";
import { getBrandAmbassadorParticipants } from "store/actions/contestAction";
import { getContests } from "store/actions/contestAction";
import Paypal from "./Paypal";
import TableComponent from "./TableComponent";

const BrandAmbassadorContest = () => {
  const dispatch = useDispatch();

  const [dataLoader, setDataLoader] = useState(false);
  const [loadMoreLoader, setLoadMoreLoader] = useState(false);
  const [loader, setLoader] = useState({
    data: false,
    partners: false,
    btnLoader: false,
  });
  const [contestStatus, setContestStatus] = useState("");
  const [contestId, setContestId] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen2, setModalOpen2] = useState(false);
  const [modalOpen3, setModalOpen3] = useState(false);
  const [payment, setPayment] = useState(false);
  const [winnerModal, setWinnerModal] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [winnerId, setWinnerId] = useState("");
  const [currentActiveTab, setCurrentActiveTab] = useState("enroll");
  const [winnerAmount, setWinnerAmount] = useState("");
  const [WinningVotes, setWinnerVotes] = useState("");
  const [winnerData, setWinnerData] = useState("");

  const {
    brandAmbassodarContestData,
    brandAmbassodarContestLastDocument,
    brandAmbassodarContestHasMoreDocument,
    brandAmbassadorParticipants,
    brandAmbassadorAthleteParticipants,
    brandAmbassadorEliminatedParticipants,
    brandAmbassadorVoters,
  } = useSelector((state) => state.contest);

  useEffect(() => {
    setDataLoader(true);
    dispatch(
      getBrandAmbassodarContests("", [], () => {
        setDataLoader(false);
      })
    );
  }, []);

  const toggle = (tab) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    setCheckedItems([]);
  };

  const toggleModal2 = () => {
    setModalOpen2(!modalOpen2);
  };
  
  const toggleModal3 = () => {
    setModalOpen3(!modalOpen3);
  };

  const toggleWinnerModal = () => {
    setWinnerModal(!winnerModal);
    setPayment(false);
  };

  const handleLoadMore = () => {
    setLoadMoreLoader(true);
    dispatch(
      getContests(
        brandAmbassodarContestLastDocument,
        brandAmbassodarContestData,
        () => {
          setLoadMoreLoader(false);
        }
      )
    );
  };
  
  const formateDate = (firestoreTimestamp) => {
    const jsDate = new Date(
      firestoreTimestamp.seconds * 1000 +
        firestoreTimestamp.nanoseconds / 1000000
    );
    const formattedDate = jsDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    return formattedDate.split("/").join("-");
  };

  const checkParticipants = (props) => {
    setContestId(props.id);
    setContestStatus(props.status);
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    toggleModal();
    dispatch(
      getBrandAmbassadorParticipants(props.id, () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };
  
  const checkEliminateParticipants = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getBrandAmbassadorEliminatedParticipants(contestId, () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };

  const seeParticipants = (id) => {
    setLoader((prev) => ({
      ...prev,
      partners: true,
    }));
    dispatch(
      getParticipants(id, () => {
        setLoader((prev) => ({
          ...prev,
          partners: false,
        }));
      })
    );
    toggleModal2();
  };
  
  const seeVoters = (id) => {
    toggleModal3();
    setLoader((prev) => ({
      ...prev,
      partners: true,
    }));
    dispatch(
      getVoters(id, () => {
        setLoader((prev) => ({
          ...prev,
          partners: false,
        }));
      })
    );
  };
  
  const handleCheckboxChange = (event, data) => {
    setWinnerVotes(data.athleteVideos.votes);
    const { checked } = event.target;
    let { id, athlete_id } = data;
    setWinnerId(athlete_id);
    if (checked) {
      setCheckedItems((prevState) => [...prevState, id]);
    } else {
      setCheckedItems((prevState) => prevState.filter((item) => item !== id));
    }
  };

  const handleSubmit = async () => {
    try {
      const uncheckedIds = brandAmbassadorParticipants
        .filter((items) => !checkedItems.includes(items.id))
        .map((uncheckedItem) => uncheckedItem.id);

      setLoader((prev) => ({
        ...prev,
        btnLoader: true,
      }));

      await dispatch(eliminateParticipants(uncheckedIds, () => {}));

      if (brandAmbassadorParticipants.length > 0) {
        await dispatch(
          updateContestLevel(
            brandAmbassadorParticipants[0].contest_id,
            () => {}
          )
        );
      }

      await dispatch(getBrandAmbassodarContests("", [], () => {}));
    } catch (error) {
      console.error(error);
    } finally {
      setLoader((prev) => ({
        ...prev,
        btnLoader: false,
      }));
    }
  };

  const handleFinal = () => {
    if (checkedItems.length == 1) {
      toggleWinnerModal();
    } else {
      toast.warning("Choose one participant winner");
    }
  };

  const getPaypalDetail = (data) => {
    let obj = {
      contest_id: contestId,
      winnerId: winnerId,
      winningAmount: winnerAmount,
      payment_id: data.id,
      WinningVotes: WinningVotes ? WinningVotes : 0,
    };

    dispatch(
      winnerAmbassador(obj, (res) => {
        if (res == "error") {
          toggleWinnerModal();
        } else {
          dispatch(
            getBrandAmbassodarContests("", [], () => {
              setPayment(false);
              setModalOpen(false);
              setWinnerModal(false);
            })
          );
        }
      })
    );
  };
  
  const checkLeaderBoard = (data) => {
    setWinnerData(data);
    setContestStatus(data.status);
    toggleWinnerModal();
  };

  // Define columns and keyMap for the main contests table
  const contestColumns = ["Start Date", "Buying End Date", "Created At", "Contest Level"];
  const contestKeyMap = {
    "Start Date": "formattedStartDate",
    "Buying End Date": "formattedEndDate",
    "Created At": "formattedCreatedAt",
    "Contest Level": "status"
  };
  
  // Pre-process data to add formatted dates
  const processedContestData = brandAmbassodarContestData ? 
    brandAmbassodarContestData.map(contest => ({
      ...contest,
      formattedStartDate: formateDate(contest.startDate),
      formattedEndDate: formateDate(contest.endDate),
      formattedCreatedAt: formateDate(contest.createdAt)
    })) : [];
  
  // Action renderer for the main table
  const renderContestActions = (row) => (
    <Button
      id="block"
      size="sm"
      color="primary"
      onClick={() => {
        if (row.status === "complete") {
          checkLeaderBoard(row);
        } else {
          checkParticipants(row);
        }
      }}
    >
      {row.status === "complete" ? "LeaderBoard" : "See Enroll Users"}
    </Button>
  );
  
  // Columns and keyMap for participants table
  const participantColumns = ["Athlete Name", "Athlete Email", "Votes"];
  const participantKeyMap = {
    "Athlete Name": "athleteName",
    "Athlete Email": "athleteEmail",
    "Votes": "votes"
  };
  
  // Pre-process participants data
  const processedParticipantsData = brandAmbassadorParticipants ?
    brandAmbassadorParticipants.map(item => ({
      ...item,
      athleteName: `${item.athlete.first_name} ${item.athlete.last_name}`,
      athleteEmail: item.athlete.email,
      votes: item?.athleteVideos?.votes ? item.athleteVideos.votes : "no videos"
    })) : [];
  
  // Action renderer for participants table
  const renderParticipantActions = (row) => (
    <>
      <input
        type="checkbox"
        checked={checkedItems.includes(row.id)}
        onChange={(event) => handleCheckboxChange(event, row)}
        className="mr-2"
      />
      <Button
        disabled={!row?.athleteVideos?.votes}
        color="primary"
        size="sm"
        onClick={() => seeParticipants(row.athleteVideos.participantList)}
        className="mr-2"
      >
        See Participants
      </Button>
      <Button
        disabled={!row?.athleteVideos?.votes}
        color="primary"
        size="sm"
        onClick={() => seeVoters(row.contest_videos_id)}
      >
        See Voters
      </Button>
    </>
  );
  
  // Columns and keyMap for eliminated participants table
  const eliminatedColumns = ["Athlete Name", "Athlete Email", "Votes"];
  const eliminatedKeyMap = {
    "Athlete Name": "athleteName",
    "Athlete Email": "athleteEmail",
    "Votes": "votes"
  };
  
  // Pre-process eliminated participants data
  const processedEliminatedData = brandAmbassadorEliminatedParticipants ?
    brandAmbassadorEliminatedParticipants.map(item => ({
      ...item,
      athleteName: `${item.athlete.first_name} ${item.athlete.last_name}`,
      athleteEmail: item.athlete.email,
      votes: item?.athleteVideos?.votes ? item.athleteVideos.votes : "no videos"
    })) : [];
  
  // Action renderer for eliminated participants table
  const renderEliminatedActions = (row) => (
    <>
      <Button
        disabled={!row?.athleteVideos?.votes}
        color="primary"
        size="sm"
        onClick={() => seeParticipants(row.athleteVideos.participantList)}
        className="mr-2"
      >
        See Participants
      </Button>
      <Button
        disabled={!row?.athleteVideos?.votes}
        color="primary"
        size="sm"
        onClick={() => seeVoters(row.contest_videos_id)}
      >
        See Voters
      </Button>
    </>
  );
  
  // Columns and keyMap for athlete partners table
  const athleteColumns = ["Athlete Name", "Athlete Email"];
  const athleteKeyMap = {
    "Athlete Name": "name",
    "Athlete Email": "email"
  };
  
  // Pre-process athlete partners data
  const processedAthleteData = brandAmbassadorAthleteParticipants ?
    brandAmbassadorAthleteParticipants.map(item => ({
      ...item,
      name: `${item.first_name} ${item.last_name}`,
      email: item.email
    })) : [];
  
  // Columns and keyMap for voters table
  const voterColumns = ["Fan Name", "Fan Email"];
  const voterKeyMap = {
    "Fan Name": "name",
    "Fan Email": "email"
  };
  
  // Columns and keyMap for winner details table
  const winnerColumns = ["Athlete Name", "Athlete Email", "Total Votes", "Winning price"];
  const winnerKeyMap = {
    "Athlete Name": "athleteName",
    "Athlete Email": "athleteEmail",
    "Total Votes": "WinningVotes",
    "Winning price": "winnerAmount"
  };
  
  // Pre-process winner data
  const processedWinnerData = winnerData ? [
    {
      athleteName: winnerData.leaderBoard.athleteName,
      athleteEmail: winnerData.leaderBoard.athleteEmail,
      WinningVotes: `${winnerData.WinningVotes}$`,
      winnerAmount: `${winnerData.winnerAmount}$`
    }
  ] : [];

  return (
    <>
      <TableComponent
        columns={contestColumns}
        data={processedContestData}
        keyMap={contestKeyMap}
        renderActions={renderContestActions}
        isLoading={dataLoader}
      />

      {!dataLoader && (
        <div className="w-100 py-4 d-flex justify-content-center">
          <Button
            color="primary"
            onClick={handleLoadMore}
            disabled={!brandAmbassodarContestHasMoreDocument}
          >
            {loadMoreLoader ? <Spinner size={"sm"} /> : "Load More"}
          </Button>
        </div>
      )}

      <Modal isOpen={modalOpen} toggle={toggleModal} size="xl" centered>
        <h1 className="text-center mt-1 mb-0 p-2 pb-0">Participants</h1>
        <ModalBody>
          {loader.data ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <Nav
                tabs
                className="d-flex justify-content-start text-dark athlete_earning-nav"
              >
                <NavItem className="px-1">
                  <NavLink
                    className={
                      currentActiveTab === "enroll"
                        ? "active active-tab py-2 "
                        : "text-dark cursor-pointer py-2 "
                    }
                    onClick={() => {
                      toggle("enroll");
                    }}
                  >
                    <h2
                      className={
                        currentActiveTab === "enroll" ? "text-white" : ""
                      }
                    >
                      Online Users
                    </h2>
                  </NavLink>
                </NavItem>
                <NavItem className="px-1">
                  <NavLink
                    className={
                      currentActiveTab === "Eliminate"
                        ? "active active-tab py-2 "
                        : "text-dark cursor-pointer py-2 "
                    }
                    onClick={() => {
                      toggle("Eliminate");
                      checkEliminateParticipants();
                    }}
                  >
                    <h2
                      className={
                        currentActiveTab === "Eliminate" ? "text-white" : ""
                      }
                    >
                      Eliminate
                    </h2>
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={currentActiveTab}>
                <TabPane tabId="enroll">
                  <Row>
                    <Col sm="12">
                      <TableComponent
                        columns={participantColumns}
                        data={processedParticipantsData}
                        keyMap={participantKeyMap}
                        renderActions={renderParticipantActions}
                        isLoading={false}
                      />
                    </Col>
                  </Row>
                </TabPane>

                <TabPane tabId="Eliminate">
                  <Row>
                    <Col sm="12">
                      <TableComponent
                        columns={eliminatedColumns}
                        data={processedEliminatedData}
                        keyMap={eliminatedKeyMap}
                        renderActions={renderEliminatedActions}
                        isLoading={false}
                      />
                    </Col>
                  </Row>
                </TabPane>
              </TabContent>
            </>
          )}
          <div className="text-right mt-4">
            <Button
              size="sm"
              color="danger"
              onClick={toggleModal}
              className="mr-2"
            >
              Close
            </Button>
            <Button
              size="sm"
              color="primary"
              onClick={() => {
                if (contestStatus == "final") {
                  handleFinal();
                } else {
                  handleSubmit();
                }
              }}
              disabled={
                loader.btnLoader || brandAmbassadorParticipants.length === 0
              }
              className="mr-2"
            >
              {loader.btnLoader ? <Spinner size="sm" /> : "Go To Next Level"}
            </Button>
          </div>
        </ModalBody>
      </Modal>
      
      <Modal isOpen={modalOpen2} toggle={toggleModal2} size="lg" centered>
        <h1 className="text-center mt-1 mb-0 p-2 pb-0">Athlete Partners</h1>
        <ModalBody>
          <TableComponent
            columns={athleteColumns}
            data={processedAthleteData}
            keyMap={athleteKeyMap}
            isLoading={loader.partners}
          />
          <div className="text-right mt-2">
            <Button color="danger" size="sm" onClick={toggleModal2}>
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal>
      
      <Modal isOpen={modalOpen3} toggle={toggleModal3} size="lg" centered>
        <h1 className="text-center mt-1 mb-0 p-2 pb-0">Voters</h1>
        <ModalBody>
          <TableComponent
            columns={voterColumns}
            data={brandAmbassadorVoters}
            keyMap={voterKeyMap}
            isLoading={loader.partners}
          />
          <div className="text-right mt-2">
            <Button color="danger" size="sm" onClick={toggleModal3}>
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal>
      
      <Modal isOpen={winnerModal} toggle={toggleWinnerModal} size="lg" centered>
        <h1 className="text-center mt-1 mb-0 p-2 pb-0">
          {contestStatus == "complete" ? "Winner Detail" : "Winner Announce"}
        </h1>
        <ModalBody>
          {contestStatus == "complete" ? (
            <TableComponent
              columns={winnerColumns}
              data={processedWinnerData}
              keyMap={winnerKeyMap}
              isLoading={false}
            />
          ) : (
            <>
              <div className="d-flex justify-content-center my-4">
                <Input
                  placeholder="Enter winner amount"
                  type="number"
                  className="w-25 mx-2"
                  value={winnerAmount}
                  onChange={(e) => setWinnerAmount(Number(e.target.value))}
                  disabled={payment}
                />
                <Button
                  disabled={payment}
                  color="primary"
                  onClick={() => setPayment(true)}
                >
                  Pay
                </Button>
              </div>
              <div className="d-flex justify-content-center">
                {payment && (
                  <Paypal
                    price={winnerAmount + 0.5}
                    getPaypalDetail={getPaypalDetail}
                  />
                )}
              </div>
            </>
          )}

          <div className="text-right mt-2">
            <Button color="danger" size="sm" onClick={toggleWinnerModal}>
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default BrandAmbassadorContest;